export default {
  type: String,
  default: 'rgba(0,0,0,0.5)'
}
